import { Table, TableContainer } from "@chakra-ui/react";
import "./HoverableTable.css";

export const HoverableTable = ({children, className = '', ...rest}) => {
  return (
		<TableContainer>
			<Table 
				variant="striped"
				colorScheme="blackAlpha" 
				fontWeight="semibold" 
				className={`table-hoverable ${className}`} 
				{...rest}
			>
				{children}
			</Table>
		</TableContainer>
  );
};